import styled from "styled-components"
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles"

export const HomePanelsWrapper = styled.section`
	background: linear-gradient(180deg, #3b5ca7 0%, #428ac9 95.37%);
	font-family: Poppins, sans-serif;
	padding-block: 6.25rem;

	h2 {
		text-align: center;
		color: white;
		margin: 0 0 2rem;
		text-wrap: balance;

		font-size: ${headingSizes.h4.desktop[0]};
		line-height: ${headingSizes.h4.desktop[1]};
		font-family: ${headingSizes.h4.fontFamily};
		font-weight: ${headingSizes.h4.fontWeight};

		@media (max-width: ${FlexipageColors.breakpointTablet}) {
			font-size: ${headingSizes.h4.tablet[0]};
			line-height: ${headingSizes.h4.tablet[1]};
		}

		@media (max-width: ${FlexipageColors.breakpointMobile}) {
			font-size: ${headingSizes.h4.mobile[0]};
			line-height: ${headingSizes.h4.mobile[1]};
		}
	}

	.panels {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(min(450px, 100%), 1fr));
		gap: 1.125rem;
	}

	.panel {
    position: relative;
		display: grid;
		grid-template-columns: auto 1fr;
		grid-template-rows: auto 1fr;
		gap: 1rem;
		padding: 2.25rem;
		background: rgba(255, 255, 255, 0.8);
		border: 1px solid white;
		border-radius: 1rem;

    transition: scale 0.1s ease-in-out;

		.icon {
			grid-column: 2;
			grid-row: 1 / -1;
			align-self: center;

			width: 120px;
			aspect-ratio: 1 / 1;

			img {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				width: 100%;
				height: 100%;
				box-sizing: border-box;

				object-fit: contain;
			}
		}

		h3 {
			color: ${FlexipageColors.blue1000};
			font-size: 1rem;
			line-height: 1.2;
			font-weight: normal;
			margin: 0;

      a {
        color: inherit;
        text-decoration: none;
        outline: 0 none;

        &::after {
          content: '';
          position: absolute;
          inset: 0;
          z-index: 50;
          border-radius: 1rem;
        }

        &:focus-visible::after {
          outline: 2px solid white;
          outline-offset: 4px;
        }
      }
		}

		p {
			color: ${FlexipageColors.blue1000};
			font-size: 1.5rem;
			line-height: 1.2;
			font-weight: 600;
			margin: 0;
		}

    &:has(a:hover, a:focus-visible) {
      scale: 1.015;
    }

		@media screen and (max-width: 490px) {
			padding: 1.5rem;

			.icon {
				width: 80px;
			}

			p {
				font-size: 1.125rem;
			}
		}
	}
`